import React, { useEffect, useState } from 'react';
import { BellIcon, XIcon } from 'lucide-react';
const NAMES = [
// Método RESET + 5 Errores (majority)
{
  name: 'Florencia B.',
  location: 'La Plata',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Lucía M.',
  location: 'Rosario',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Martín D.',
  location: 'Buenos Aires',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Valentina R.',
  location: 'Córdoba',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Diego S.',
  location: 'Mendoza',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Sofía L.',
  location: 'Mar del Plata',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Nicolás F.',
  location: 'Tucumán',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Carolina G.',
  location: 'Buenos Aires',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Facundo R.',
  location: 'Rosario',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Andrea C.',
  location: 'Neuquén',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Pablo A.',
  location: 'La Plata',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Camila T.',
  location: 'Salta',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Gonzalo M.',
  location: 'Córdoba',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Agustina V.',
  location: 'Buenos Aires',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Sebastián L.',
  location: 'Santa Fe',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Marcela P.',
  location: 'Rosario',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Tomás H.',
  location: 'Mendoza',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Julieta K.',
  location: 'Buenos Aires',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Matías G.',
  location: 'Mar del Plata',
  product: 'Método RESET + Los 5 Errores'
}, {
  name: 'Romina S.',
  location: 'Tucumán',
  product: 'Método RESET + Los 5 Errores'
},
// Método RESET 24 H. (some)
{
  name: 'María J.',
  location: 'Córdoba',
  product: 'Método RESET 24 H.'
}, {
  name: 'Fernando P.',
  location: 'Buenos Aires',
  product: 'Método RESET 24 H.'
}, {
  name: 'Laura N.',
  location: 'Rosario',
  product: 'Método RESET 24 H.'
}, {
  name: 'Alejandro B.',
  location: 'Mendoza',
  product: 'Método RESET 24 H.'
}, {
  name: 'Daniela R.',
  location: 'La Plata',
  product: 'Método RESET 24 H.'
}, {
  name: 'Santiago M.',
  location: 'Neuquén',
  product: 'Método RESET 24 H.'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    location: '',
    product: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomPerson = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 2;
      setCurrentPurchase({
        name: randomPerson.name,
        location: randomPerson.location,
        product: randomPerson.product,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const interval = setInterval(showPopup, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-50 animate-slide-in-left font-['Lato',sans-serif]" data-id="element-401">
      <div className="bg-white rounded-r-lg shadow-[0_4px_20px_rgba(0,0,0,0.15)] border-l-4 border-l-[#27AE60] p-4 max-w-[320px] flex items-start gap-3 relative" data-id="element-402">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-403">
          <XIcon className="w-4 h-4" data-id="element-404" />
        </button>

        <div className="mt-1" data-id="element-405">
          <BellIcon className="w-5 h-5 text-[#27AE60]" fill="#27AE60" fillOpacity={0.2} data-id="element-406" />
        </div>

        <div className="flex-1 pr-4" data-id="element-407">
          <p className="text-xs font-bold text-[#27AE60] uppercase tracking-wide mb-1" data-id="element-408">
            Compra verificada
          </p>
          <p className="text-sm text-[#444444] leading-snug" data-id="element-409">
            <strong data-id="element-410">{currentPurchase.name}</strong> de{' '}
            {currentPurchase.location} compró {currentPurchase.product} 💑
          </p>
          <p className="text-xs text-gray-500 mt-1.5" data-id="element-411">
            hace {currentPurchase.time} minutos
          </p>
        </div>
      </div>
    </div>;
}